package pl.michal_cyran.brand_hub.subpages.dayMathAd.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaIcon
import com.varabyte.kobweb.silk.components.icons.fa.IconCategory
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.LineStyle.Companion.Solid
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun ExplanationCard(
    title: String,
    body: String,
    icon: String,
    modifier: Modifier = Modifier,
) {
    val cm = ColorMode.current.toSitePalette()
    Row(
        modifier = modifier
            .fillMaxWidth()
            .borderLeft(4.px, color = cm.primary, style = Solid)
            .borderRadius(1.cssRem)
            .backgroundColor(cm.cardBg)
            .padding(leftRight = 2.cssRem),
        horizontalArrangement = Arrangement.spacedBy(2.cssRem),
        verticalAlignment = Alignment.CenterVertically
    ) {
        FaIcon(
            icon,
            style = IconCategory.SOLID,
            size = IconSize.XXL,
            modifier = Modifier.color(cm.primary)
        )
        Column {
            P(
                Modifier
                    .fontWeight(700)
                    .color(ColorMode.current.toSitePalette().textMuted)
                    .toAttrs()
            ) {
                Text(
                    title
                )
            }
            P(
                Modifier
                    .fontSize(0.875.cssRem)
                    .lineHeight(1.25.cssRem)
                    .toAttrs()
            )  {
                Text(
                    body,
                )
            }
        }
    }
}